import ReactMarkdown from "react-markdown";
import { Box, Spinner } from "@chakra-ui/react";
import remarkGfm from "remark-gfm"; // Optional: tables, strikethrough, task lists

const MarkdownMessage = ({ content, isStreaming }) => {
    return (
        <Box
            bg={isStreaming ? "gray.50" : "transparent"}
            px={8}
            py={2}
            borderRadius="md"
            fontSize="md"
        >
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
            {isStreaming && <Spinner size="xs" mt={2} />}
        </Box>
    );
};
export default MarkdownMessage;
